import { cn } from '@/lib/utils';

interface BudgetNodeIconProps {
  hasChildren: boolean;
  className?: string;
  size?: number;
}

/** Folder (parent) vs leaf icon — shared by tree picker and child summary rows. */
export function BudgetNodeIcon({ hasChildren, className, size = 14 }: BudgetNodeIconProps) {
  const shared = cn('flex-shrink-0 text-muted-foreground', className);

  if (hasChildren) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={shared}
        aria-hidden="true"
        data-testid="budget-node-icon-folder"
      >
        <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
      </svg>
    );
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={shared}
      aria-hidden="true"
      data-testid="budget-node-icon-leaf"
    >
      <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
      <path d="M3 9h18" />
    </svg>
  );
}
